import { render, staticRenderFns } from "./IssueTypeNewEdit.vue?vue&type=template&id=3424689b&scoped=true&"
import script from "./IssueTypeNewEdit.vue?vue&type=script&lang=js&"
export * from "./IssueTypeNewEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3424689b",
  null
  
)

export default component.exports